import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useMutation } from "@tanstack/react-query"

interface UseCreateContactProps {
  establishmentLeadId?: string
  onSuccess?: () => void
  onError?: () => void
}

export const useCreateEstablishmentLeadContact = ({
  establishmentLeadId,
  onSuccess,
  onError
}: UseCreateContactProps) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['createPrivateCompanyLeadContact'],
    mutationFn: async () => {
      const lead = {
        contacts_attributes: [
          { _create: true }
        ]
      }

      return privateAxios.put(`/funnel/establishment/leads/${establishmentLeadId}`, {
        lead
      })
    },
    onSuccess,
    onError,
  })
}
